export const MAX_CONDITIONS_PER_STATEMENT = 2;
export const MAX_TRANCHES_PER_INSTRUMENT = 5;
